import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, We are iConcept IT Solutions Team`}</h1>
    <p>{`Our company offers a complete and diverse line of computer software packages that are geared
and focused on automation of Local Government Units (LGU) operations.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      